import { CancelText } from 'owa-locstrings/lib/strings/canceltext.locstring.json';
import { applyButton, applyButtonAriaLabel } from './strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react-lite';

const styles = require('./ActionButtons.scss');

export interface ActionButtonsProps {
    onApplyClicked: () => void;
    onCancelClicked: () => void;
    isApplyDisabled: boolean;
}

const ActionButtons = observer(function ActionButtons(props: ActionButtonsProps) {
    return (
        <div className={styles.container}>
            <div className={styles.buttonContainer}>
                <PrimaryButton
                    className={styles.button}
                    disabled={props.isApplyDisabled}
                    ariaLabel={applyButtonAriaLabel}
                    onClick={props.onApplyClicked}>
                    {loc(applyButton)}
                </PrimaryButton>

                <span className={styles.cancelButtonContainer}>
                    <DefaultButton
                        className={styles.button}
                        ariaLabel={loc(CancelText)}
                        onClick={props.onCancelClicked}>
                        {loc(CancelText)}
                    </DefaultButton>
                </span>
            </div>
        </div>
    );
});
export default ActionButtons;
